import React from 'react';

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconCurrencyDollar, IconBrandChrome, IconBell, IconSettings } from '@tabler/icons';
import { ReactComponent as EnviagoLogo } from 'assets/images/enviago-logo-short.svg';

// constant
const icons = { IconBrandChrome, IconCurrencyDollar, IconBell, IconSettings };

// ===========================|| WELCOME MENU ITEMS ||=========================== //

const welcome = (isShowEnviagoMenuItem) => {
    const enviagoMenuItem = isShowEnviagoMenuItem
        ? {
              id: 'enviago',
              title: 'Enviar o recibir dinero',
              type: 'item',
              url: '/enviago',
              icon: EnviagoLogo,
              breadcrumbs: false,
              inactiveHide: true
          }
        : null;

    return {
        id: 'welcome-roadmap',
        type: 'group',
        title: <FormattedMessage id="welcome" />,
        inactiveHide: true,
        children: [
            {
                id: 'dashboard',
                title: <FormattedMessage id="dashboard" />,
                type: 'item',
                url: '/dashboard',
                icon: icons.IconBrandChrome,
                breadcrumbs: false,
                inactiveHide: true
            },
            {
                id: 'payments',
                title: <FormattedMessage id="payments" />,
                type: 'item',
                url: '/payments',
                icon: icons.IconCurrencyDollar,
                breadcrumbs: false,
                inactiveHide: true
            },
            {
                id: 'notifications',
                title: <FormattedMessage id="notifications" />,
                type: 'item',
                url: '/notifications',
                icon: icons.IconBell,
                breadcrumbs: false,
                inactiveHide: true
            },
            {
                id: 'settings',
                title: <FormattedMessage id="settings" />,
                type: 'item',
                url: '/settings',
                icon: icons.IconSettings,
                breadcrumbs: false,
                inactiveHide: true
            },
            enviagoMenuItem
        ].filter(Boolean)
    };
};

export default welcome;
